import LeadMobileCard from './LeadMobileCard.component';

export default LeadMobileCard;